import React, { useCallback, useEffect, useRef, useState } from "react";
import logo from "../../images/logo.png";
import ngSvg from "../../images/svgs/ng.svg";
import saSvg from "../../images/sa.svg";
import dropDownSvg from "../../images/svgs/arrow.svg";
import { NavLink } from "react-router-dom";
import { useRecoilState } from "recoil";
import { auth_user } from "../../atom";
import { saveToken } from "../../lib/utils";
import { useNavigate } from "react-router-dom";
import { useLogout } from "../../api/mutations";

const Nav = ({ isPublic = false }) => {
  const [user, set_user] = useRecoilState(auth_user);
  const [openModal, setOpenModal] = useState(false);
  const [toggleCountry, setToggle] = useState(false);
  const [selectecCountry, setSelectedCountry] = useState({
    img: ngSvg,
    name: "NGN",
  });
  const ref = useRef(null);
  const navigate = useNavigate();
  const { mutateAsync } = useLogout();

  const handleLogout = useCallback(async () => {
    try {
      await mutateAsync();
      set_user({});
      saveToken("accessToken", "");
      saveToken("refreshToken", "");
      navigate("/");
    } catch (e) {}
  }, []);

  useEffect(() => {
    document.addEventListener(
      "click",
      function (e) {
        if (!ref.current?.contains(e.target)) {
          setOpenModal(false);
        }
      },
      true
    );
  }, [ref]);

  return (
    <div className="landing-row">
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">

          {/* ✅ LOGO (INCREASED SIZE) */}
          <NavLink to="/">
            <div style={{ backgroundColor: "#fff" }}>
              <img
                src={logo}
                className="img-fluid logo"
                alt="logo"
                style={{ height: "60px", width: "auto" }} // 🔥 increased size
              />
            </div>
          </NavLink>

          <ul className="flex items-center">
            <li className="nav-item">
              <NavLink to="/">
                <span className="nav-link">Free Bet codes</span>
              </NavLink>
            </li>

            {!isPublic && Object.keys(user).length ? (
              <li className="nav-item">
                <NavLink to="/mybets">
                  <span className="nav-link">My Bets</span>
                </NavLink>
              </li>
            ) : null}
          </ul>

          <div className="flex" id="navbarText">
            <div className="flex justify-center items-center gap-0">

              {/* 🌍 LANGUAGE SELECTOR */}
              <div
                onClick={() => setToggle((prev) => !prev)}
                className="flex cursor-pointer relative justify-center mt-[20px] items-center gap-2"
              >
                <img src={selectecCountry.img} className="w-[25px] h-[25px]" />
                <h4 className="font-bold text-sm text-black-100">
                  {selectecCountry.name}
                </h4>
                <img src={dropDownSvg} className="w-[20px] h-[20px]" />

                {toggleCountry && (
                  <div
                    ref={ref}
                    className="absolute w-[100px] mt-[80px] py-2 bg-white shadow-md rounded-md p-4"
                  >
                    <p
                      onClick={() => {
                        if (selectecCountry.name === "NGN") {
                          setSelectedCountry({ img: saSvg, name: "SA" });
                        } else {
                          setSelectedCountry({ img: ngSvg, name: "NGN" });
                        }
                      }}
                      className="font-medium cursor-pointer text-sm text-black"
                    >
                      <div className="flex justify-center items-center gap-2">
                        <img
                          src={selectecCountry.name === "NGN" ? saSvg : ngSvg}
                          className="w-[25px] h-[25px]"
                        />
                        <h4 className="font-bold text-sm">
                          {selectecCountry.name === "NGN" ? "SA" : "NGN"}
                        </h4>
                      </div>
                    </p>
                  </div>
                )}
              </div>

              {/* ✅ LOGIN BUTTON (NEW) */}
              {!Object.keys(user ?? {}).length && (
                <NavLink to="/login">
                  <button className="btn-copy-header mt-6">
                    Login
                  </button>
                </NavLink>
              )}

              {/* USER / GET STARTED */}
              {Object.keys(user ?? {}).length && !isPublic ? (
                <div className="flex cursor-pointer relative justify-center mt-[20px] ml-6 items-center gap-2">
                  <h4 className="font-bold text-sm text-black-100">
                    Hi, {user?.username}
                  </h4>
                  <img
                    onClick={() => setOpenModal((prev) => !prev)}
                    src={dropDownSvg}
                    className="w-[20px] h-[20px]"
                  />
                  {openModal && (
                    <div
                      ref={ref}
                      className="absolute w-[100px] mt-[80px] py-2 bg-white shadow-md rounded-md p-4"
                    >
                      <p
                        onClick={handleLogout}
                        className="font-medium cursor-pointer text-sm text-black"
                      >
                        Logout
                      </p>
                    </div>
                  )}
                </div>
              ) : (
                <span className="navbar-text mt-6">
                  <NavLink to="/signup">
                    <button className="btn-copy-header">
                      Get started
                    </button>
                  </NavLink>
                </span>
              )}
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Nav;